var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbl-prop-comp-combined',{staticClass:"mt-2",attrs:{"project":_vm.project,"decorateNumerals":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }